module.exports = __webpack_public_path__ + "static/media/DT9.4ddda07e.jpg";